import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';
import { InquiryListItem } from '../models/inquiry-list-item';

export const INQUIRIES_REQUEST = 'INQUIRIES_REQUEST';
export const INQUIRIES_RECEIVE = 'INQUIRIES_RECEIVE';

const receiveInquiries = (inquiries: PaginatedResponse<InquiryListItem>) => {
    return {
        type: INQUIRIES_RECEIVE,
        inquiries,
    };
};

export const fetchInquiries = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: INQUIRIES_REQUEST });

        const response = await api.inquiry.cget(searchParams);

        if (response.success) {
            dispatch(receiveInquiries(response.result));
        }
    };
};
